import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Modal, Tabs, Tab } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import AddShift from './addShift.js';
import TableWidget from '../../TableWidget.js';
import Button from '~/components/CustomButton/CustomButton.jsx';

//elements
import Select from '~/elements/Select.js';
import LoadingSpinner from '~/elements/LoadingSpinner';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

//utils
import { timeFormat, totalTimeFormat } from '~/utils/dateFormat.js';
import { translateLabels } from '~/utils/commonMethods';

const week_days = [
    { value: 0, label: "Sunday", title: "Sunday", key: "Sunday" },
    { value: 1, label: "Monday", title: "Monday", key: "Monday" },
    { value: 2, label: "Tuesday", title: "Tuesday", key: "Tuesday" },
    { value: 3, label: "Wednesday", title: "Wednesday", key: "Wednesday" },
    { value: 4, label: "Thursday", title: "Thursday", key: "Thursday" },
    { value: 5, label: "Friday", title: "Friday", key: "Friday" },
    { value: 6, label: "Saturday", title: "Saturday", key: "Saturday" }
];

const formatData = function (data, t, dateTimeRules) {
    return data.map(item => ({
        name: item.shift_name,
        timing: `${t("From")} ${timeFormat(item.start_time, dateTimeRules)} ${t("to")} ${timeFormat(item.end_time, dateTimeRules)}`,
        short_code: item.short_code,
        factor: `1:${item?.factor} (${totalTimeFormat(Math.round(item?.normal_work_day / item?.factor), dateTimeRules)}${t('hr')})`,
        shift_color: item.shift_color ? (
            <div className='d-flex justify-content-center'>
                <div
                    style={{
                        width: "40px",
                        height: "25px",
                        backgroundColor: item.shift_color,
                        borderRadius: "12px",
                        border: "1px solid #ccc",
                        boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                    }}
                />
            </div>
        ) : null
    }));
}

class CompanyShift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            standardWeekStartDay: 1,
            maxHoursForAutoLogout: 13,
            CompanyShift: [],
            isEdit: false,
            editData: {},
            loading: false,
            overTimeEditMode: false,
            activeTab: 'shiftCodes',
            codeType: null
        }
        this.updateData = this.updateData.bind(this);
        this.deleteShift = this.deleteShift.bind(this);
        this.handleDataDelete = this.handleDataDelete.bind(this);
    }

    updateData = async (data, saveAndReload, codeType) => {
        const { commonStore, t, clientStore } = this.props;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        this.setState({ loading: true }, async () => {
            try {
                let newShiftId;
                if (this.state?.editData?.id)
                    await clientStore.editCompanyShift(this.state.editData.id, data);
                else {
                    const { companyShift } = await clientStore.saveCompanyShift(data);
                    newShiftId = companyShift.id;
                }
                commonStore.addNotification(t('Company Shift saved successfully!'), null, 'success');
                if (!saveAndReload)
                    this.loadCompanyShifts();
                else
                    this.loadCompanyShiftById(this.state?.editData?.id || newShiftId, true, codeType);
            } catch (err) {
                console.error(err)
                this.setState({ loading: false })
            }
        });
    }

    componentDidMount() {
        this.setState({ loading: true }, this.loadData);
    }

    loadData = async () => {
        const { currentEntity } = this.props.clientStore;
        const { standardWeekStartDay, maxHoursForAutoLogout, allowWeeklyCalculation, weeklyCalculationSettings, maxConsecutiveWorkingSunday } = this.state;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            this.setState({
                standardWeekStartDay: basicRules.standardWeekStartDay || standardWeekStartDay,
                maxHoursForAutoLogout: basicRules?.maxHoursForAutoLogout || maxHoursForAutoLogout,
                loading: true
            }, this.loadCompanyShifts)
        }
    }

    

    loadCompanyShifts = async () => {
        const { clientStore, commonStore, t } = this.props;
        try {
            const result = await clientStore.getCompanyShift();
            const shifts = result?.companyShift || [];
            const companyShifts = commonStore.sortCompanyShifts(result.companyShift, true);
            this.setState({
                CompanyShift: companyShifts,
                loading: false,
                isEdit: false,
                editData: {},
            });
        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong!'), null, 'error');
            this.setState({ loading: false });
        }
    }

    handleInputRange = (e) => {
        e.persist();
        if (e.target.value < 12 || e.target.value > 23) return;
        let _maxHoursForAutoLogout = e.target.value;
        this.props.handleUserDataChange('maxHoursForAutoLogout', _maxHoursForAutoLogout);
        this.setState({ maxHoursForAutoLogout: _maxHoursForAutoLogout });
    }

    deleteShift = async (id) => {
        const { clientStore, commonStore, t } = this.props;
        try {
            await clientStore.deleteCompanyShift(id, false);
            commonStore.addNotification(t('Shift deleted successfully!'), null, 'success');
            this.loadCompanyShifts()
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    handleDataDelete = (index, list = this.state.CompanyShift) => {
        const data = list[index];
        const id = data?.id;

        if (!id) return;
        this.setState({ loading: true }, () => {
            return this.props.handleDelete(id, (id) => {
                return this.deleteShift(id);
            }, null, () => this.setState({ loading: false }));
        })
    }

    editShift = (index, list = this.state.CompanyShift, codeType = null) => {
        const data = list[index];
        const id = data.id;
        if (!id) return;
        this.setState({ loading: true }, () => this.loadCompanyShiftById(id, false, codeType));
    }

    loadCompanyShiftById = async (id, overtimeEditMode = false, codeType = null) => {
        try {
            const result = await this.props.clientStore.getCompanyShiftById(id);
            this.toggleModal(true, result.companyShift, overtimeEditMode, codeType);
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    toggleModal = (value, data, overtimeEditMode = false, codeType = null) => {
        this.setState({ isEdit: value, editData: data, loading: false, overtimeEditMode, codeType });
    }

    renderAddNewButton = (codeType, dataLength, maxRowAllowed) => {
        const { t } = this.props;
        const isRowLimitExceed = maxRowAllowed && dataLength?.length > maxRowAllowed;
        return (
            <Row className='mt-3 align-items-center'>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button wd fill onClick={() => this.toggleModal(true, {}, false, codeType)} disabled={isRowLimitExceed} title={isRowLimitExceed ? `${t('Shift')} ${t('Max Limit')}` : t('Add new')}>
                        <i className="fa fa-plus-circle fa-xl margin-right-10" /> {t('Add new')}
                    </Button>
                </Col>
            </Row>
        )
    }

    render() {
        const { t, commonStore } = this.props;
        const { overtimeSettingList } = this.props.clientStore;
        const dateTimeRules = commonStore.getDateTimeRules();
        translateLabels(week_days, t, 'label');
        const overtimeOptions = overtimeSettingList?.map((o) => ({ value: o.id, label: o.name }));
        const { standardWeekStartDay, isEdit, loading, activeTab, codeType } = this.state;

        if (loading) return <LoadingSpinner />

        const shiftCodesList = this.state.CompanyShift.filter(s => s.shift_type !== 'freeShift' && s.shift_type !== 'standbyShift');
        const fCodesList = this.state.CompanyShift.filter(s => s.shift_type === 'freeShift');
        const standbyCodesList = this.state.CompanyShift.filter(s => s.shift_type === 'standbyShift');
        const tableMetaData = [
            { field: 'name', type: 'text' },
            { field: 'timing', type: 'text' },
            { field: 'short_code', type: 'text' },
            { field: 'shift_color', type: 'color', html: true }
        ];

        return (
            <>
                <Row>
                    <Col xs={3}>
                        <label className="control-label">{t('Week')} {t('Start')} {t('Day')}</label>
                        <Select
                            options={week_days}
                            value={week_days.find(item => item.value === standardWeekStartDay)}
                            onChange={evt => {
                                this.setState({ standardWeekStartDay: evt.value })
                                this.props.handleUserDataChange('standardWeekStartDay', evt.value)
                            }}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col xs={6}>
                        <label className="control-label">{t('Maximum allowed hours before auto finish working log')}</label>
                        <div className="slider-parent">
                            <input type="range" min="12" max="23"
                                onChange={event => this.handleInputRange(event)}
                                value={this.state.maxHoursForAutoLogout}
                            />
                            <div className="buble">
                                {this.state.maxHoursForAutoLogout} {t('Hours')}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Tabs activeKey={activeTab} onSelect={(key) => this.setState({ activeTab: key })} id="companyShiftsTabs" className="mt-3">
                    <Tab eventKey="shiftCodes" title={t('Shift Codes')}>
                        {this.renderAddNewButton('shiftCodes')}
                        <TableWidget
                            page={'companyShifts'}
                            headers={['Name', 'Timing', 'Short Code', 'Color']}
                            metaData={tableMetaData}
                            data={formatData(shiftCodesList, t, dateTimeRules)}
                            onChange={_ => { }}
                            customDeleteHandler={(idx) => this.handleDataDelete(idx, shiftCodesList)}
                            customFormHandler={(idx) => this.editShift(idx, shiftCodesList, 'shiftCodes')}
                            minRemoveIndex={0}
                        />
                    </Tab>
                    <Tab eventKey="freeShift" title={t('Free Codes')}>
                        <TableWidget
                            page={'companyFCodes'}
                            headers={['Name', 'Short Code', 'Color']}
                            metaData={tableMetaData.filter(ele => ele.field !== 'timing')}
                            data={formatData(fCodesList, t, dateTimeRules)}
                            onChange={_ => { }}
                            customFormHandler={(idx) => this.editShift(idx, fCodesList)}
                            minRemoveIndex={fCodesList.length}
                        />
                    </Tab>
                    <Tab eventKey="standbyCodes" title={t('Standby Codes')}>
                        {this.renderAddNewButton('standbyCodes', standbyCodesList, 10)}
                        <TableWidget
                            page={'companyStandbyCodes'}
                            headers={['Name', 'Timing', 'Short Code', 'factor', 'Color']}
                            metaData={tableMetaData.toSpliced(3,0, { field: 'factor', type: 'text' })}
                            data={formatData(standbyCodesList, t, dateTimeRules)}
                            onChange={_ => { }}
                            customFormHandler={(idx) => this.editShift(idx, standbyCodesList, 'standbyCodes')}
                        />
                    </Tab>
                </Tabs>
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {}, false, null)}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Company Shifts')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {}, false, null)}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <AddShift
                            val={this.state.editData}
                            updateData={this.updateData}
                            edit={isEdit}
                            overtimeSettingList={overtimeOptions}
                            cancel={() => this.toggleModal(false, {}, false, null)}
                            t={this.props.t}
                            dateTimeRules={dateTimeRules}
                            overtimeEditMode={this.state.overtimeEditMode}
                            codeType={this.state.codeType}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(withRemoveDialog(observer(CompanyShift))));
